<template>
  <div class="notificationEdit">
    <el-dialog
      :title="type | titleName"
      :visible.sync="visible"
      width="750px"
      :before-close="close"
      :close-on-click-modal="false"
      :close-on-press-escape="false">
      <div class="content">
        <el-form ref="form" :model="form" :rules="rules" label-width="110px">
          <el-form-item label="公告类型" prop="announcementType">
            <el-select v-model="form.announcementType" clearable :disabled="type === 'view'" placeholder="请选择公告类型">
              <el-option label="系统更新" :value="1"></el-option>
              <el-option label="运营通知" :value="2"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="标题" prop="title">
            <el-input v-model="form.title" clearable maxlength="30" show-word-limit :disabled="type === 'view'" placeholder="请输入公告标题"></el-input>
          </el-form-item>
          <el-form-item label="公告内容" prop="contentHtml">
            <quillEditor
              ref="quillEditor"
              class="quill_editor"
              v-model="form.contentHtml"
              :options="quillEditorOption"
              @blur="onQuillEditorBlur">
            </quillEditor>
          </el-form-item>
          <el-form-item label="员工类型" prop="audienceUserTypes">
            <el-select v-model="form.audienceUserTypes" clearable multiple :disabled="type === 'view'" style="width: 480px;" placeholder="请选择员工类型（可多选）" @change="userTypeChange">
              <el-option label="全部" value="all"></el-option>
              <el-option label="医生" value="0" :disabled="form.audienceUserTypes.includes('all')"></el-option>
              <el-option label="医助" value="1" :disabled="form.audienceUserTypes.includes('all')"></el-option>
              <el-option label="员工" value="2" :disabled="form.audienceUserTypes.includes('all')"></el-option>
              <el-option label="其他" value="3" :disabled="form.audienceUserTypes.includes('all')"></el-option>
              <el-option label="理疗师" value="4" :disabled="form.audienceUserTypes.includes('all')"></el-option>
              <el-option label="药师" value="5" :disabled="form.audienceUserTypes.includes('all')"></el-option>
              <el-option label="护士" value="6" :disabled="form.audienceUserTypes.includes('all')"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="是否弹窗提示" prop="popup">
            <el-radio-group v-model="form.popup" :disabled="type === 'view'" @input="popupChange">
              <el-radio :label="true">是</el-radio>
              <el-radio :label="false">否</el-radio>
            </el-radio-group>
          </el-form-item>
          <el-form-item v-if="form.popup" label="弹出频率" prop="popupMode">
            <el-radio-group v-model="form.popupMode" :disabled="type === 'view'">
              <el-radio :label="1">弹出一次</el-radio>
              <el-radio :label="2">未读时每次登录弹出</el-radio>
            </el-radio-group>
          </el-form-item>
        </el-form>
      </div>
      <div slot="footer" class="footer">
        <el-button v-if="type !== 'view'" @click="close">取 消</el-button>
        <el-button v-if="type !== 'view'" type="primary" :loading="loading" @click="confirm">确 定</el-button>
        <el-button v-if="type === 'view'" @click="close">关 闭</el-button>
      </div>
    </el-dialog>
    <Upload ref="uploadImage" style="visibility: hidden;" @on-success="uploadImgSuccess" accept=".png,.jpg,.jpeg"></Upload>
  </div>
</template>

<script>
  var fontSize = ['12px', '14px', '16px', '18px', '20px', '24px', '28px', '32px', '36px']

  import req from '@/utils/request'

  import Upload from "@/components/Upload/Upload";

  import 'quill/dist/quill.core.css'
  import 'quill/dist/quill.snow.css'
  import 'quill/dist/quill.bubble.css'

  import { quillEditor, Quill } from 'vue-quill-editor'

  window.Quill = Quill

  const Size = Quill.import('attributors/style/size')
  Size.whitelist = fontSize
  Quill.register(Size, true)

  const ColorStyle = Quill.import('attributors/style/color');
  Quill.register(ColorStyle, true);

  const BackgroundStyle = Quill.import('attributors/style/background');
  Quill.register(BackgroundStyle, true)

  const AlignStyle = Quill.import('attributors/style/align');
  AlignStyle.whitelist = ['right', 'center', 'justify'];
  Quill.register(AlignStyle, true);

  const ImageResize = require('quill-image-resize-module').default
  Quill.register('modules/imageResize', ImageResize)

  export default {
    name: 'notificationEdit',
    components: {
      quillEditor,
      Upload
    },
    data() {
      return {
        type: 'add', // add: 新增, edit: 编辑, view: 查看
        id: null,
        visible: false,
        loading: false,
        quillEditorOption: {
          theme: 'snow',
          placeholder: '请输入公告内容',
          modules: {
            imageResize: {
              displaySize: true
            },
            toolbar: [
              ['bold', 'italic', 'underline', 'strike'],  // 加粗、斜体等
              [{ list: 'ordered' }, { list: 'bullet' }],  // 有序、无序列表
              [{ size: fontSize }],  // 字号
              [{ color: [] }, { background: [] }],  // 字体颜色、背景色
              [{ align: [] }],  // 对齐方式
              ['link', 'image'],
              ['clean'] // 清除格式
            ]
          }
        },
        rules: {
          announcementType: [{ required: true, message: '请选择公告类型', trigger: 'change' }],
          title: [{ required: true, message: '请输入公告标题', trigger: 'blur' }],
          contentHtml: [{ required: true, message: '请输入公告内容', trigger: 'blur' }],
          audienceUserTypes: [{ required: true, message: '请选择员工类型', trigger: 'change' }],
          popup: [{ required: true, message: '请选择是否弹窗提示', trigger: 'change' }]
        },
        form: {
          announcementType: '',
          title: '',
          contentHtml: '',
          audienceUserTypes: [],
          popup: false,
          popupMode: 1,
          version: 0
        }
      }
    },
    filters: {
      titleName (value) {
        const titleMap = {
          'add': '新增公告',
          'edit': '编辑公告',
          'view': '查看公告'
        }
        return titleMap[value]
      }
    },
    methods: {
      init () {
        const quill = this.$refs.quillEditor.quill
        const toolbar = quill.getModule('toolbar')
        toolbar.addHandler('image', () => {
          if (this.type === 'view') {
            return
          }
          this.$refs.uploadImage.$el.querySelector('input').click()
        })

        if (this.type === 'view') {
          quill.enable(false)
        } else {
          quill.enable(true)
        }
      },
      async open (type = 'add', id = null) {
        this.type = type
        this.id = id
        this.visible = true
        this.$nextTick(() => {
          this.init()
        })

        if (id) {
          const res = await req.get(`/announcement/manage/detail`, { announcementId: id })
          if (res.code === 200) {
            this.form.announcementType = res.data.announcementType
            this.form.title = res.data.title
            this.form.contentHtml = res.data.contentHtml
            this.form.audienceUserTypes = ['0', '1', '2', '3', '4', '5', '6'].every(num => res.data.audienceUserTypes.includes(num)) ? ['all'] : res.data.audienceUserTypes
            this.form.popup = res.data.popup
            this.form.popupMode = res.data.popupMode
            this.form.version = res.data.version
          }
        }
      },
      async uploadImgSuccess (data) {
        let arr = []
        arr[0] = { uploadChannel: "postImg", fileId: data, groupName: "group1", isNeedThumbnail: "2" }
        const uploadRes = await req.post('/upload/fdfs/file/upload/fdfs', arr, '/xl')
        if (uploadRes.errorCode == '0000') {
          const imageUrl = uploadRes.data && uploadRes.data[0] && uploadRes.data[0].fullPathUrl || ''
          if (imageUrl) {
            const quill = this.$refs.quillEditor.quill
            const range = quill.getSelection()
            if (range) {
              // 在光标位置插入图片
              quill.insertEmbed(range.index, 'image', imageUrl)
            }
          }
        }
      },
      onQuillEditorBlur () {
        this.$refs.form.validateField('contentHtml')
      },
      userTypeChange (value) {
        if (value.includes('all')) {
          this.form.audienceUserTypes = ['all']
        } else {
          if (['0', '1', '2', '3', '4', '5', '6'].every(num => this.form.audienceUserTypes.includes(num))) {
            this.form.audienceUserTypes = ['all']
          }
        }
      },
      popupChange (value) {
        this.form.popupMode = 1
      },
      close () {
        this.visible = false
        this.type = 'add'
        this.id = null
        this.form = {
          announcementType: '',
          title: '',
          contentHtml: '',
          audienceUserTypes: [],
          popup: false,
          popupMode: 1,
          version: 0
        }
        this.$refs.form.resetFields()
      },
      confirm () {
        this.$refs.form.validate(async (valid) => {
          if (valid) {
            this.loading = true
            const params = {
              ...this.form,
              audienceUserTypes: this.form.audienceUserTypes.length === 1 && this.form.audienceUserTypes[0] === 'all' ? ['0', '1', '2', '3', '4', '5', '6'] : this.form.audienceUserTypes,
              announcementId: this.id
            }
            let url = '/announcement/manage'
            if (this.type === 'edit') {
              url = '/announcement/manage/update'
            }
            const res = await req.post(url, params)
            this.loading = false
            if (res.code === 200) {
              this.$message.success('保存成功')
              this.close()
              this.$emit('confirm')
            }
          }
        })
      }
    }
  }
</script>

<style lang="less" scoped>
  .notificationEdit /deep/ .el-dialog__header {
    padding: 12px 24px;
  }

  .notificationEdit /deep/ .el-dialog__title {
    line-height: 24px;
    font-weight: 600;
    font-size: 16px;
    color: #000000;
  }

  .notificationEdit /deep/ .el-dialog__headerbtn {
    top: 16px;
  }

  .notificationEdit /deep/ .el-dialog__body {
    padding: 0px;
  }

  .notificationEdit /deep/ .el-dialog__footer {
    padding: 0px;
  }

  .content {
    box-sizing: border-box;
    padding: 16px 24px;
    width: 100%;
  }

  .quill_editor {
    line-height: 1;
  }

  .quill_editor /deep/ .ql-container {
    height: 240px;
  }

  .footer {
    box-sizing: border-box;
    padding: 16px 24px;
    width: 100%;
    border-top: 1px solid #EBEAEE;
  }
</style>
